//#region src/utils/promiseBuffer.ts
function createPromiseBuffer(options) {
	const { size, concurrency } = options;
	const buffer = [];
	let inProgress = 0;
	const work = () => {
		if (inProgress < concurrency && buffer.length) {
			const { producer, resolve, reject } = buffer.shift();
			inProgress++;
			producer().then((result) => {
				inProgress--;
				work();
				resolve(result);
			}, (reason) => {
				inProgress--;
				work();
				reject(reason);
			});
		}
	};
	const add = (promiseProducer) => {
		if (buffer.length + inProgress >= size) throw new Error("Task buffer full");
		return new Promise((resolve, reject) => {
			buffer.push({
				producer: promiseProducer,
				resolve,
				reject
			});
			work();
		});
	};
	return { add };
}
//#endregion
export { createPromiseBuffer };

//# sourceMappingURL=promiseBuffer.js.map